import moment from 'moment-timezone';

import floor from 'lodash/floor';
import get from 'lodash/get';


const INTERVAL_OPTIONS  = [
  { label: '1 min', bucket: 'minute', milliseconds: 60*1000, intervalFormat: 'MM/DD/YYYY, h:mm a' },
  { label: '15 min', bucket: 'minute', milliseconds: 15*60*1000, intervalFormat: 'MM/DD/YYYY, h:mm a' },
  { label: 'hour', bucket: 'hour', milliseconds: 60*60*1000, intervalFormat: 'MM/DD/YYYY, hA' },
  { label: 'day', bucket: 'hour', milliseconds: 24*60*60*1000, intervalFormat: 'MM/DD/YYYY' },
  { label: 'week', bucket: 'hour', milliseconds: 7*24*60*60*1000, intervalFormat: 'MM/DD/YYYY' },
  { label: 'month', bucket: 'hour', milliseconds: 30*24*60*60*1000, intervalFormat: 'MMM YYYY' }
];

const LEGACY_SOURCES = [
  'news',
  'blogs',
  'facebook',
  'reddit',
  'videos',
  'instagram',
  'broadcast',
  'forum',
  'qa',
  'review',
  'lexis_nexis',
  'weibo',
  'vk',
  'twitter',
  'dark_web'
];

const _getPeriodFormatDate = (timestamp, selectedInterval) => {
  const { label, intervalFormat } = selectedInterval;
  const date = moment.utc(timestamp);

  if (label === '15 min') {
    const minutes = date.minutes();
    const minutePeriod = minutes ? floor(minutes/15) * 15 : 0;
    date.minutes(minutePeriod);
  }
  if (label === 'week') {
    // use Monday for start of each week interval
    date.day(1);
  }

  return date.format(intervalFormat);
};

/**
 * Format terms and tickers data into an object suitable for parsing.
 * @param terms Array of strings
 * @param tickers Array of strings
 * @returns {{fields: string[], data: any[][]}} Object that is parsed by Papa Parse.
 * See https://www.papaparse.com/docs#json-to-csv
 */
/** TODO: add stock info when implemented */
const transformForExport = (termsData, intervalOption) => {
  const columns = termsData.map(i => i.label);
  const fields = ['Date'];

  // ensures all legacy sources are represented even if 0, and include platforms as they're added or enabled
  const allSourceSet = new Set(LEGACY_SOURCES);
  termsData.forEach(termData =>
    Object.keys(get(termData, 'sources', {})).forEach(source => allSourceSet.add(source))
  );
  const receivedSources = Array.from(allSourceSet);
  columns.forEach(column => {
    const subColumns = receivedSources.map(src => `${column} - ${src}`);
    fields.push(column);
    fields.push(...subColumns);
  });

  const body = termsData[0].points.map(obj => {
    const formattedDate = _getPeriodFormatDate(obj.timestamp, intervalOption);
    return [formattedDate];
  });

  termsData.forEach(({points}) => {
    points.forEach((point, idx) => {
      body[idx].push(point.value);
      receivedSources.forEach(source => {
        const total = point.sources[source] || 0;
        body[idx].push(total);
      });
    });
  });

  return {
    fields,
    data: body.reverse()
  };
};

const formatChartData = (data, selectedSource) => {
  return(data.map((datum) => {
    const newValues = {...datum};

    if (selectedSource !== 'allSources') {
      newValues.points = datum.points.map((point) => ({
        timestamp: point.timestamp,
        value: point.sources[selectedSource] || 0
      }));
      newValues.total = newValues.points.reduce((a, b) => a + b.value, 0);
    }

    return {
      type: 'line',
      ...newValues,
      ...{
        axis: 'y',
        color: datum.color,
        label: datum.label,
      }
    };
  }));
};

export {
  INTERVAL_OPTIONS,
  transformForExport,
  formatChartData
};

